import React from 'react';
import { Accordion, Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { SECONDARY_COLOR, PRIMARY_COLOR, WHITE_COLOR } from '../colors';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
* The accordion is a graphical control element comprising a vertical stacked list of items.
* each item must have a title and id
* The parameter showAccordionItems handles that the content of a item is shown or not
* Parameters (props)
* @param bool showArrows: show the arrows dropdown and triangle right
* @param array accordionItems = mandatory
*             { id string ,
                title string,
                accordionContent object ,
                onClick func: if onClick is null then the arrow icon will be not shown
                icon object,
              }
* @param object showAccordionItems = mandatory {
*    id: true/false = the same id used in accordionItems
* }
* @param bool showContent: if show content is false, it will only show the titless
* of the accordion
*
* Note: the id from the array accordionItem, must be the same id in the object showAccordionItems
*/
export default class UiAccordion extends React.PureComponent {
  render() {
    const {
      accordionItems,
      showAccordionItems,
      showArrows,
      showContent,
      mode,
    } = this.props;
    const styleWrapper = { backgroundColor: WHITE_COLOR };
    const styleTitle = {
      borderTopColor: SECONDARY_COLOR,
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
    };
    const styleTitleSelected = { backgroundColor: SECONDARY_COLOR };
    const styleSeparator = { backgroundColor: PRIMARY_COLOR };
    if (mode !== null) {
      const modeColors = colorsModeUI(mode);
      styleWrapper.backgroundColor = 'inherit';
      styleTitle.backgroundColor = modeColors.ACCORDION_TITLE_BACKGROUND_COLOR;
      styleTitle.borderTopColor = modeColors.ACCORDION_TITLE_BORDER_COLOR;
      styleTitle.color = modeColors.ACCORDION_TITLE_COLOR;
      styleTitleSelected.backgroundColor =
        modeColors.ACCORDION_SELECTED_TITLE_BACKGROUND_COLOR;
      styleTitleSelected.color = modeColors.ACCORDION_SELECTED_TITLE_COLOR;
      styleSeparator.backgroundColor =
        modeColors.ACCORDION_SELECTED_TITLE_BACKGROUND_COLOR;
    }
    return (
      <Accordion className="ui-accordion" style={styleWrapper}>
        {accordionItems.map((accordionItem) => (
          <div key={accordionItem.id}>
            <Accordion.Title
              index={accordionItem.id}
              active={showAccordionItems[accordionItem.id]}
              onClick={accordionItem.onClick}
              style={{
                ...styleTitle,
                ...(showAccordionItems[accordionItem.id]
                  ? styleTitleSelected
                  : {}),
              }}
            >
              {/* the arrow in the title will be only show if a handleClick event is passed */}
              {showAccordionItems[accordionItem.id]
                ? showArrows &&
                  accordionItem.onClick && <Icon name="dropdown" />
                : showArrows &&
                  accordionItem.onClick && <Icon name="triangle right" />}
              {accordionItem.icon && accordionItem.icon}
              {accordionItem.title}
            </Accordion.Title>
            {showContent && showAccordionItems[accordionItem.id] && (
              <Accordion.Content
                active
                className="separator"
                style={styleSeparator}
              >
                <div />
              </Accordion.Content>
            )}
            {showContent && (
              <Accordion.Content
                active={showAccordionItems[accordionItem.id]}
                className="content"
              >
                {showAccordionItems[accordionItem.id] &&
                  accordionItem.accordionContent}
              </Accordion.Content>
            )}
            {showContent && showAccordionItems[accordionItem.id] && (
              <Accordion.Content
                active
                className="separator bottom "
                style={styleSeparator}
              >
                <div />
              </Accordion.Content>
            )}
          </div>
        ))}
      </Accordion>
    );
  }
}

UiAccordion.propTypes = {
  showArrows: PropTypes.bool,
  accordionItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      accordionContent: PropTypes.Object,
      id: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      icon: PropTypes.Object,
    })
  ).isRequired,
  showAccordionItems: PropTypes.objectOf(PropTypes.bool).isRequired,
  showContent: PropTypes.bool,
  mode: PropTypes.string,
};

UiAccordion.defaultProps = {
  showArrows: false,
  showContent: true,
  mode: null,
};
